import React, { createContext, useContext, useState, useCallback } from "react";

const translations = {
  en: {
    org: "Anonymous Violence Support Program",
    brand: "It's okay",
    hero_title: "Every voice deserves to be heard.",
    hero_sub:
      "Anonymous space for survivors of domestic and sexual violence, harassment and trauma.",
    open_map: "Open the map",
    voices_heard: "voices heard",
    updated_live: "updated live",
    stat_voices: "Voices",
    stat_countries: "Countries",
    stat_month: "This month",
    how_title: "How it works",
    how_sub: "You stay anonymous the entire way.",
    how_1_t: "Read the map",
    how_1_d: "Each mark is a real voice — a survivor who chose to leave a small light behind for others.",
    how_2_t: "Place your mark",
    how_2_d: "Click anywhere on the map, choose a symbol that feels like yours, and write in your own words.",
    how_3_t: "It is reviewed with care",
    how_3_d: "Every story is gently reviewed before it appears, keeping this a safe, respectful space.",
    footer_need_help: "Need help right now?",
    footer_resources: "Support resources & hotlines",
    footer_note: "This is a peer support space for speaking up, not a substitute for emergency services.",
    quick_exit: "Quick exit",
    moderation: "Moderation access",
    // map
    map_title: "The map of voices",
    map_hint: "Click anywhere on the map to add your own voice.",
    add_voice: "Add your voice",
    filters: "Filters",
    f_all: "All voices",
    f_recent: "Recent",
    by_symbol: "By symbol",
    by_category: "By category",
    clear: "Clear",
    back_home: "Home",
    // categories
    cat_domestic: "Domestic",
    cat_sexual: "Sexual",
    cat_harassment: "Harassment",
    cat_psychological: "Psychological",
    cat_other: "Other",
    // symbols
    sym_candle: "Candle",
    sym_dove: "Dove",
    sym_star: "Star",
    sym_leaf: "Leaf",
    sym_wave: "Wave",
    sym_circle: "Circle",
    sym_heart: "Heart",
    // panel
    panel_title: "Leave your voice",
    panel_sub: "Your marker will appear here after a gentle review.",
    choose_symbol: "Choose a symbol",
    choose_category: "Type of experience",
    your_words: "In your own words",
    placeholder_text: "Share as much or as little as you wish. There is no right way to do this…",
    nickname: "Nickname (optional)",
    nickname_ph: "Anonymous",
    disclaimer:
      "Every story is reviewed before it appears on the map. Please do not include real names, addresses, or anything that could identify you or someone else.",
    cancel: "Cancel",
    submit: "Submit for review",
    submitting: "Sending…",
    submitted_toast: "Thank you. Your voice has been sent for a gentle review.",
    error_toast: "Something went wrong. Please try again.",
    // content warning
    cw_title: "Heads up",
    cw_body:
      "This map holds real experiences of violence and trauma, written by survivors. Leave whenever you need to.",
    cw_tip: "Tip: press the Escape key at any time to leave this site instantly.",
    cw_enter: "I understand — enter the map",
    cw_leave: "Take me somewhere safe",
    // resources
    res_title: "You are not alone",
    res_sub: "If you are in immediate danger, contact your local emergency number first.",
    res_global: "Global",
    res_ru: "Russia",
    res_back: "Back to map",
    // admin
    admin_title: "Moderation",
    admin_sub: "Review voices with care before they appear on the map.",
    email: "Email",
    password: "Password",
    sign_in: "Sign in",
    signing_in: "Signing in…",
    logout: "Log out",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    approve: "Approve",
    reject: "Reject",
    no_pending: "No voices waiting for review. All caught up.",
    login_error: "Invalid email or password.",
  },
  ru: {
    org: "Anonymous Violence Support Program",
    brand: "Всё хорошо",
    hero_title: "Каждый голос заслуживает быть услышанным.",
    hero_sub:
      "Анонимное пространство для переживших домашнее и сексуальное насилие, домогательства и травму.",
    open_map: "Открыть карту",
    voices_heard: "голосов услышано",
    updated_live: "обновляется в реальном времени",
    stat_voices: "Голоса",
    stat_countries: "Страны",
    stat_month: "За этот месяц",
    how_title: "Как это работает",
    how_sub: "Вы остаётесь анонимными на всём пути.",
    how_1_t: "Читайте карту",
    how_1_d: "Каждая метка — реальный голос человека, оставившего тёплый огонёк для других.",
    how_2_t: "Поставьте свою метку",
    how_2_d: "Нажмите в любом месте карты, выберите близкий вам символ и напишите своими словами.",
    how_3_t: "Всё бережно проверяется",
    how_3_d: "Каждая история мягко проверяется перед публикацией — так пространство остаётся безопасным.",
    footer_need_help: "Нужна помощь прямо сейчас?",
    footer_resources: "Ресурсы поддержки и горячие линии",
    footer_note: "Это пространство взаимоподдержки, чтобы высказаться, а не замена экстренным службам.",
    quick_exit: "Быстрый выход",
    moderation: "Доступ к модерации",
    map_title: "Карта голосов",
    map_hint: "Нажмите в любом месте карты, чтобы добавить свой голос.",
    add_voice: "Добавить голос",
    filters: "Фильтры",
    f_all: "Все голоса",
    f_recent: "Недавние",
    by_symbol: "По символу",
    by_category: "По категории",
    clear: "Сбросить",
    back_home: "На главную",
    cat_domestic: "Домашнее",
    cat_sexual: "Сексуальное",
    cat_harassment: "Домогательства",
    cat_psychological: "Психологическое",
    cat_other: "Другое",
    sym_candle: "Свеча",
    sym_dove: "Голубь",
    sym_star: "Звезда",
    sym_leaf: "Лист",
    sym_wave: "Волна",
    sym_circle: "Круг",
    sym_heart: "Сердце",
    panel_title: "Оставьте свой голос",
    panel_sub: "Ваша метка появится здесь после бережной проверки.",
    choose_symbol: "Выберите символ",
    choose_category: "Тип опыта",
    your_words: "Вашими словами",
    placeholder_text: "Поделитесь настолько, насколько хотите. Здесь нет правильного способа…",
    nickname: "Никнейм (необязательно)",
    nickname_ph: "Anonymous",
    disclaimer:
      "Каждая история проверяется перед появлением на карте. Пожалуйста, не указывайте настоящие имена, адреса или что-либо, что может вас или кого-то раскрыть.",
    cancel: "Отмена",
    submit: "Отправить на проверку",
    submitting: "Отправляем…",
    submitted_toast: "Спасибо. Ваш голос отправлен на бережную проверку.",
    error_toast: "Что-то пошло не так. Попробуйте ещё раз.",
    cw_title: "Предупреждение",
    cw_body:
      "На этой карте — реальный опыт насилия и травмы, написанный пережившими. Уходите, когда вам нужно.",
    cw_tip: "Подсказка: нажмите клавишу Escape в любой момент, чтобы мгновенно покинуть сайт.",
    cw_enter: "Я понимаю — войти на карту",
    cw_leave: "Отвести меня в безопасное место",
    res_title: "Вы не одни",
    res_sub: "Если вам угрожает непосредственная опасность, сначала позвоните в местную экстренную службу.",
    res_global: "Глобальные",
    res_ru: "Россия",
    res_back: "Назад к карте",
    admin_title: "Модерация",
    admin_sub: "Бережно проверяйте голоса перед публикацией на карте.",
    email: "Эл. почта",
    password: "Пароль",
    sign_in: "Войти",
    signing_in: "Вход…",
    logout: "Выйти",
    pending: "На проверке",
    approved: "Одобрено",
    rejected: "Отклонено",
    approve: "Одобрить",
    reject: "Отклонить",
    no_pending: "Нет голосов, ожидающих проверки. Всё разобрано.",
    login_error: "Неверная почта или пароль.",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("avsp_lang") || "en");
  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("avsp_lang", l);
  }, []);
  const t = useCallback((key) => translations[lang][key] ?? key, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
